module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAADElEQVQIHWPQt/EDAAFXALplUH7IAAAAAElFTkSuQmCC"